import { Component, Input, Output,
         EventEmitter, ChangeDetectorRef } from '@angular/core';

import { Catalog } from '../shared';


@Component({
  selector: 'igo-catalog-list',
  template: require('./catalog-list.component.html'),
  styles: [require('./catalog-list.component.styl')]
})
export class CatalogListComponent {

  @Input()
  get catalogs(): Catalog[] { return this._catalogs; }
  set catalogs(value: Catalog[]) {
    this._catalogs = value;
  }
  private _catalogs: Catalog[];

  @Input()
  get selectedCatalog(): Catalog { return this._selectedCatalog; }
  set selectedCatalog(value: Catalog) {
    this._selectedCatalog = value;
    this.cdRef.detectChanges();
  }
  private _selectedCatalog: Catalog;

  @Output() select = new EventEmitter<Catalog>();
  @Output() unselect = new EventEmitter<Catalog>();

  constructor(private cdRef: ChangeDetectorRef) {}

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/catalog/catalog-list/catalog-list.component.ts